import { render, staticRenderFns } from "./GatheringStep3.vue?vue&type=template&id=5295a0f9&scoped=true&"
import script from "./GatheringStep3.vue?vue&type=script&lang=js&"
export * from "./GatheringStep3.vue?vue&type=script&lang=js&"
import style0 from "./GatheringStep3.vue?vue&type=style&index=0&id=5295a0f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5295a0f9",
  null
  
)

export default component.exports